import { PrescriptionType } from "../../../../utils/global-types";
import { ColumnDef } from "@tanstack/react-table";
import { DeleteDialog } from "./DeleteDialog";
export const columns = ({
  getPrescriptionData,
}: {
  getPrescriptionData: any;
}): ColumnDef<PrescriptionType>[] => [
  {
    id: "actions",
    cell: ({ row }) => {
      const prescription = row.original;

      return (
        <DeleteDialog
          row={prescription}
          getPrescriptionData={getPrescriptionData}
        />
      );
    },
  },
  {
    accessorKey: "brandDrugName",
    header: "Brand Drug Name",
  },
  {
    accessorKey: "brandDrugFormulationType",
    header: "Drug Formulation",
  },
  {
    accessorKey: "genericDrugName",
    header: "Generic Drug",
  },
  {
    accessorKey: "prescriptionFrequencyDescription",
    header: "Prescription Frequency",
  },
  {
    accessorKey: "prescriptionFrequencyTranslation",
    header: "Frequency Translation",
  },
  {
    accessorKey: "prescriptionLengthDescription",
    header: "Prescription Length",
  },
  {
    accessorKey: "notes",
    header: "Notes",
  },
];
